import {
  IGenerateStrategyProps,
  IStrategy,
  Leg,
  ViewType,
} from "../../../types";
import { analyzePositions } from "../../analyzeProfits";

export const generateLongStraddle = (
  params: IGenerateStrategyProps,
  strategies: IStrategy[],
  atmCallIndex: number,
  atmPutIndex: number,
  expiryDuration: number
): IStrategy[] => {
  const atmCallStrike = params.data.strikePrices[atmCallIndex];
  //const atmPutStrike = params.data.strikePrices[atmPutIndex];
  const callData = params.data.data.find(
    (val) =>
      val.expiryDates === params.expiryDate && val.strikePrice === atmCallStrike
  );
  const putData = params.data.data.find(
    (val) =>
      val.expiryDates === params.expiryDate && val.strikePrice === atmCallStrike
  );

  const legs: Leg[] = [
    {
      strikePrice: atmCallStrike,
      price: callData?.CE?.lastPrice || 0,
      buy: true,
      call: true,
      quantity: params.lotSize,
    },
    {
      strikePrice: atmCallStrike,
      price: putData?.PE?.lastPrice || 0,
      buy: true,
      call: false,
      quantity: params.lotSize,
    },
  ];
  const analysis = analyzePositions(legs);
  const marginRequired = (legs[0].price + legs[1].price) * params.lotSize;
  const strategy: IStrategy = {
    legs: legs,
    riskRewardRatio: 1,
    maxProfit: Infinity,
    maxLoss: analysis.maxLoss,
    approxMargin: marginRequired,
    expiryDuration: expiryDuration,
    title: "Long Straddle " + atmCallStrike,
    maxLossROI: (analysis.maxLoss * 100) / marginRequired,
    maxProfitROI: Infinity,
    callBreakEven: analysis.breakEven.callBreakEven,
    putBreakEven: analysis.breakEven.putBreakEven,
    callBreakEvenPercentage:
      ((analysis.breakEven.callBreakEven - params.data.underlyingValue) /
        params.data.underlyingValue) *
      100,
    putBreakEvenPercentage:
      ((analysis.breakEven.putBreakEven - params.data.underlyingValue) /
        params.data.underlyingValue) *
      100,
    lotSize: params.lotSize,
    alert:
      "Long Straddle is a risky strategy. High chance for premium erosion if market does not move.",
    types: [ViewType["Extremely Positive"], ViewType["Extremely Negative"]],
  };
  strategies.push(strategy);
  return strategies;
};
